import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const evidenceIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 64"><path d="M37.1 0H0v64h53V16L37.1 0zm0 8l7.95 8H37.1V8zM5.3 58.667V5.333h26.5v16h15.9v37.334H5.3z"/></svg>`
);
